// extracted by mini-css-extract-plugin
module.exports = {"heading":"ColumnSection_heading__27uIV"};